module.exports = __webpack_public_path__ + "img/苦参.2353dac5.jpg";